import axios from 'axios'
import config from '@/config'
function getUrl() {
    if (window.location.href.indexOf('?api=') !== -1) {
        let baseUrl = ''
        if (window.location.href.indexOf('&port=') !== -1) {
            baseUrl = window.location.protocol + '//' + window.location.href.substring(window.location.href.indexOf('?api=') + 5, window.location.href.indexOf('&port=')) + ':' + window.location.href.substring(window.location.href.indexOf('&port=') + 6) + '/'
        } else {
            baseUrl = window.location.protocol + '//' + window.location.href.substring(window.location.href.indexOf('?api=') + 5) + '/'
        }
        sessionStorage.setItem('url', baseUrl)
    } else {
        if (window.location.origin + '/#/login' === window.location.href) {
            sessionStorage.removeItem('url')
        }
    }
}

let baseUrl = function parseApiUrl() {
    getUrl()
    let url = sessionStorage.getItem('url') == null ? '1' : sessionStorage.getItem('url')
    if (url == '1') {
        let apiUrl
        if (process.env.NODE_ENV == 'development') {
            apiUrl = 'https://topapi.h5sdk.store/' // 开发环境
        } else {
            // apiUrl = `https://topapi.h5sdk.store/` // 生产环境
            // @ts-ignore
            apiUrl = `${window.ipConfigUrl.baseURL}`; // 生产环境
        }
        return apiUrl
    } else {
        let apiUrl
        if (process.env.NODE_ENV == 'development') {
            apiUrl = url // intest 环境
        } else {
            apiUrl = url
        }
        return apiUrl
    }
}

axios.interceptors.request.use(
    (config) => {
        // 解决 axios 多发送 Request Method: OPTIONS 请求问题
        ;(config.headers as object)['Content-Type'] = 'text/plain'
        config.url = baseUrl() + config.url
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)
axios.interceptors.response.use(
    (response) => {
        return response
    },
    (error) => {
        return Promise.reject(error)
    }
)

export default axios
